import React from "react";
import AppSuggestion from "../AppSugestoion/AppSuggestion";
import SecCard from "../Cards/SecCard";
import useTitle from "../../Hooks/useTitle";
import scrollToTop from "../ScrollTop/ScrollTop";
import { useNavigate } from "react-router-dom";

const VisaAndOthers = () => {
  useTitle("Visa And Others");
  const navigate = useNavigate();

  React.useEffect(() => {
    scrollToTop();
  }, []);

  const services = [
    {
      id: 1,
      title: "VISA",
      title_b: "ভিসা",
      to: "/visa",
    },
    {
      id: 2,
      title: "Tickets",
      title_b: "টিকেটস",
      to: "/ticket",
    },
    {
      id: 3,
      title: "Tours & Travels",
      title_b: "টুরস-ট্রাভেলস",
      to: "/tour",
    },
  ];

  return (
    <div>
      <div className="services visa">
        {services.map((item, index) => (
          <SecCard
            key={item.id}
            index={index}
            title={item.title}
            title_b={item.title_b}
            // img={item.img}
            onClick={() => navigate(item.to)}
          />
        ))}
      </div>

      <AppSuggestion />
    </div>
  );
};

export default VisaAndOthers;
